import React from 'react';

const BlogSection = ({ 
  badge = "Resources & Insights",
  title = "Explore helpful articles, guides, and technical resources."
}) => {
  const blogPosts = [
  {
    id: 1,
    date: '15.01.2026',
    title: 'Complete Guide to Migrating from AWS to Hetzner Cloud',
    description: 'Learn how to move your servers, databases, and applications from AWS to Hetzner Cloud while reducing infrastructure costs and maintaining performance.',
    link: '',
    tags: ['#AWS', '#Hetzner', '#Migration']
  },
  {
    id: 2,
    date: '10.01.2026',
    title: 'Top Open Source Alternatives to AWS Services',
    description: 'Discover powerful open-source replacements for AWS RDS, Cognito, CloudWatch, Elastic Beanstalk, and other managed services to reduce vendor lock-in.',
    link: '',
    tags: ['#OpenSource', '#AWS', '#DevOps']
  },
  {
    id: 3,
    date: '05.01.2026',
    title: 'How Companies Save Up to 90% by Moving to Hetzner',
    description: 'See real-world examples of businesses cutting cloud costs dramatically by migrating workloads from AWS, Azure, and Google Cloud to Hetzner.',
    link: '',
    tags: ['#CloudCosts', '#Hetzner', '#Infrastructure']
  }
];

  const ArrowIcon = () => (
    <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
    </svg>
  );

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-4">
        
        <div className="text-center mb-12">
          <span className="text-blue-600 font-semibold text-xs uppercase tracking-wider">
            {badge}
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-2 mb-4">
            {title}
          </h2>
          <div className="w-16 h-1 bg-green-600 mx-auto"></div>
        </div>
        
        <div className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {blogPosts.map((post) => (
            <article 
              key={post.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden group hover:shadow-xl transition-all duration-300"
            >
              <a className="block" hreflang="en" href={post.link}>
                <div className="h-2 bg-gradient-to-r from-green-600 to-blue-400"></div>
                <div className="p-6 space-y-4">
                  <p className="text-sm text-gray-500 font-medium">{post.date}</p>
                  <h3 className="text-xl font-bold text-gray-900 group-hover:text-green-600 transition-colors duration-300 line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 line-clamp-3">{post.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {post.tags.map((tag, idx) => (
                      <span key={idx} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="pt-4">
                    <span className="inline-flex items-center text-green-600 font-semibold group-hover:gap-2 transition-all duration-300">
                      Read More
                      <ArrowIcon />
                    </span>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
        
      </div>
    </section>
  );
};

export default BlogSection;